import { faCalendar } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Card, Table } from "react-bootstrap";
import moment from "moment";
import { faLayerGroup, faShapes, faUsers } from "@fortawesome/free-solid-svg-icons";

const ClassCard = (props) => {
    const { c } = props;
    //console.log(c);
    return (
        <Card id="classCard" className="shadow-sm">
            <Card.Body className="p-2">
                <Table size="sm" borderless className="mb-0">
                    <tbody>
                        <tr>
                            <td rowSpan={2} className="align-middle p-0 pe-1 lh-1">
                                <FontAwesomeIcon icon={faCalendar} />
                            </td>
                            <td className="align-bottom bold pb-0 lh-1">{moment(c.class_start_time).format("DD.MM.YYYY")}</td>
                            <td className="align-middle bold pb-0 lh-1">{c.class_name}</td>
                            <td className="align-middle pe-0 lh-1 pb-0 class-level">
                                <FontAwesomeIcon icon={faLayerGroup} className="me-1" />
                                {c.class_level_name.length > 8 ? c.class_level_name.substr(0, 8) + "." : c.class_level_name}
                            </td>
                            <td className="align-middle pe-0 lh-1 pb-0 class-level">
                                <FontAwesomeIcon icon={faShapes} className="me-1" />
                                {c.class_type_name}
                            </td>
                        </tr>
                        <tr>
                            <td className="align-middle bold lh-1 class-start-time">
                                {moment(c.class_start_time).format("HH:mm")}–{moment(c.class_end_time).format("HH:mm")}
                            </td>
                            <td className="align-middle lh-1">
                                {c.instructor_name} {c.instructor_surname}
                            </td>
                            <td className="align-middle pe-0 lh-1">
                                <FontAwesomeIcon icon={faUsers} className="me-1" />
                                {c.class_slots - c.free_slots + c.cnt_waitlist}/{c.class_slots}
                            </td>
                        </tr>
                    </tbody>
                </Table>
            </Card.Body>
        </Card>
    );
};

export default ClassCard;
